export default "__VITE_ASSET__CjFcirG4__"